import {React} from 'common'
import {Colors, Styles} from 'appearance'
import Toolbar from '@mui/material/Toolbar'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import MuiAppBar from '@mui/material/AppBar'
import SearchArea from './Header/SearchArea'
import HeaderTitle from './Header/HeaderTitle'
import HeaderActions from './Header/HeaderActions'
import {useIsRtl} from 'store/Store'
import useHeaderMenu from 'logic/Menu/useHeaderMenu'
import ProfileMenu from './Header/ProfileMenu'
import NotificationsMenu from './Header/NotificationsMenu'
import {useDeviceDetect} from 'services/hooks'
import HamburgerButton from 'components/Control/HamburgerButton'

const Header = ({open, toggleDrawer}) => {
    open = false
    const isRtl = useIsRtl()
    const {isMobile} = useDeviceDetect()
    const {anchors, isMenuOpen, handleOpenMenu, handleCloseMenu} =
        useHeaderMenu()

    const menuId = 'primary-search-account-menu'

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar
                position="fixed"
                open={open}
                isrtl={isRtl ? 1 : 0}
                isMobile={isMobile}>
                <AppToolbar style={{height: Styles.HEADER_HEIGHT}}>
                    {isMobile ? (
                        <HamburgerButton
                            onClick={() => {
                                console.log('hamburger')
                                toggleDrawer()
                            }}
                        />
                    ) : (
                        <>
                            <HeaderTitle />
                            <SearchArea />
                        </>
                    )}
                    <HeaderActions
                        menuId={menuId}
                        handleOpenMenu={handleOpenMenu}
                    />
                </AppToolbar>
                {isMobile && (
                    <AppToolbar style={{height: Styles.HEADER_HEIGHT}}>
                        <SearchArea />
                    </AppToolbar>
                )}
            </AppBar>

            <ProfileMenu
                menuId={menuId}
                anchorEl={anchors.profile}
                isMenuOpen={isMenuOpen}
                handleCloseMenu={handleCloseMenu}
            />

            <NotificationsMenu
                menuId={menuId}
                anchorEl={anchors.notifications}
                isMenuOpen={isMenuOpen}
                handleCloseMenu={handleCloseMenu}
            />
        </Box>
    )
}

export default Header

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open, isrtl, isMobile}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: isrtl ? 0 : Styles.DRAWER_WIDTH,
        marginRight: isrtl ? Styles.DRAWER_WIDTH : 0,
        width: `calc(100% - ${Styles.DRAWER_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    height: isMobile ? 63 : 87,
}))

const AppToolbar = styled(Toolbar)`
    background: ${Colors.APP_WHITE};
    justify-content: space-between;
`
